import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCard = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M3.333 2h9.333c.884.001 1.731.353 2.356.977s.976 1.472.977 2.356v5.333c-.001.884-.353 1.731-.977 2.356s-1.472.976-2.356.977H3.333c-.884-.001-1.731-.353-2.356-.977S.001 11.55 0 10.667V5.333c.001-.884.353-1.731.977-2.356S2.45 2.001 3.333 2zm9.333 1.333H3.333a2 2 0 0 0-2 2h13.333a2 2 0 0 0-2-2zm-9.333 9.333h9.333a2 2 0 0 0 2-2v-4H1.333v4a2 2 0 0 0 2 2zm1.334-2.331a1 1 0 1 1-2 0 1 1 0 1 1 2 0z",
		fill: "#333"
	})
});
export default SvgCard;
